import { EditableDataGrid } from "../../../builderPackage/components/editableDataGrid/editableDataGrid";
export var CustomerComplaintEditableDataGrid = function (props) {
    var onChange = props.onChange, value = props.value, error = props.error, _a = props.name, name = _a === void 0 ? 'CustomerComplaints' : _a, disabled = props.disabled;
    var currValue = value === null || value === void 0 ? void 0 : value[name];
    // only UAT v2.5
    // const data = useParams()
    // const customerComplaintColumns: IEditableDataGridProps['columns'] = [
    //     {
    //         type: 'searchSelect',
    //         field: 'ComplaintName',
    //         headerName: 'Customer Complaint',
    //         width: 200,
    //         headerAlign: 'left',
    //         editable: true,
    //         getListData: complaintTypeGetComplaintAPICall,
    //         getOptionLabel: (option: any) => option?.ComplaintName,
    //         valueFormatter: (value: any) => value?.ComplaintName ?? '',
    //         apiKey: 'complaintTypeGetComplaints',
    //         valueSetter(value: any, row) {
    //             return {
    //                 ...row,
    //                 ComplaintName: value?.ComplaintName,
    //                 ComplaintId: value?.ComplaintId
    //             };
    //         },
    //         valueGetter(val, row) {
    //             return {
    //                 ComplaintName: row?.ComplaintName ?? '',
    //                 id: row?.ComplaintId ?? ''
    //             }
    //         }
    //     },
    //     {
    //         type: 'searchSelect',
    //         field: 'ObservationName',
    //         headerName: 'Observation',
    //         width: 200,
    //         headerAlign: 'left',
    //         editable: true,
    //         getListData: complaintTypeObservationAPICall,
    //         apiKey: 'ComplaintsObservationList',
    //         getOptionLabel: (option: any) => option?.ComplaintName ?? '',
    //         valueFormatter: (value: any) => value?.ComplaintName ?? '',
    //         valueSetter(value: any, row) {
    //             return {
    //                 ...row,
    //                 ObservationName: value?.ComplaintName,
    //                 ObservationId: value?.ComplaintId
    //             };
    //         },
    //         valueGetter(val, row) {
    //             return {
    //                 ComplaintName: row?.ObservationName,
    //                 id: row?.ObservationId
    //             }
    //         }
    //     },
    //     {
    //         type: 'searchSelect',
    //         field: 'ActionTakenName',
    //         headerName: 'Action Taken',
    //         width: 200,
    //         headerAlign: 'left',
    //         editable: true,
    //         getListData: complaintTypeActionTakenAPICall,
    //         apiKey: 'actionTakenList',
    //         getOptionLabel: (option: any) => option?.ComplaintName ?? '',
    //         valueFormatter: (value: any) => value?.ComplaintName ?? '',
    //         valueSetter(value: any, row) {
    //             return {
    //                 ...row,
    //                 ActionTakenName: value?.ComplaintName,
    //                 ActionTakenId: value?.ComplaintId
    //             };
    //         },
    //         valueGetter(val, row) {
    //             return {
    //                 ComplaintName: row?.ActionTakenName,
    //                 id: row?.ActionTakenId
    //             }
    //         }
    //     },
    //     {
    //         field: 'ServiceAdvisorSuggestions',
    //         headerName: 'SA Suggestion',
    //         width: 200,
    //         headerAlign: 'left',
    //         editable: true,
    //     },
    //     {
    //         field: 'CustomerAdditionalRemarks',
    //         headerName: 'Customer Remark',
    //         width: 200,
    //         headerAlign: 'left',
    //         editable: true,
    //     },
    //     {
    //         type: 'searchSelect',
    //         field: 'CVTypeName',
    //         headerName: 'CV Type',
    //         width: 150,
    //         headerAlign: 'left',
    //         editable: true,
    //         getListData: CustomerVoiceCVTypeListAPICall,
    //         apiKey: 'customerVoiceCVTypeList',
    //         getOptionLabel: (option: any) => option?.DisplayName ?? '',
    //         valueFormatter: (value: any) => value?.DisplayName ?? '',
    //         valueSetter(value: any, row) {
    //             return {
    //                 ...row,
    //                 CVTypeName: value?.DisplayName,
    //                 CVType: value?.id
    //             };
    //         },
    //         valueGetter(val, row) {
    //             return {
    //                 DisplayName: row?.CVTypeName,
    //                 id: row?.CVType
    //             }
    //         }
    //     },
    //     {
    //         field: 'PDIInspectionComments',
    //         headerName: 'PDI Inspection',
    //         width: 150,
    //         headerAlign: 'left',
    //         editable: true,
    //     },
    //     {
    //         type: 'searchSelect',
    //         field: 'SubCategoryName',
    //         headerName: 'Sub category',
    //         width: 150,
    //         headerAlign: 'left',
    //         editable: true,
    //         getListData: complaintSubCategoryAPICall,
    //         apiKey: 'subCategory',
    //         apiRequest: { JobCardId: data?.id },
    //         getOptionLabel: (option: any) => option?.DisplayName ?? '',
    //         valueFormatter: (value: any) => value?.DisplayName ?? '',
    //         valueSetter(value: any, row) {
    //             return {
    //                 ...row,
    //                 SubCategoryName: value?.DisplayName,
    //                 SubCategoryId: value?.id
    //             };
    //         },
    //         valueGetter(val, row) {
    //             return {
    //                 DisplayName: row?.SubCategoryName,
    //                 id: row?.SubCategoryId
    //             }
    //         }
    //     },
    //     {
    //         type: 'searchSelect',
    //         field: 'CustomerVoiceName',
    //         headerName: 'Customer voice from',
    //         width: 150,
    //         headerAlign: 'left',
    //         editable: false,
    //         // getListData: CustomerVoiceFromListAPICall,
    //         // apiKey: 'customerVoiceFromList',
    //         // getOptionLabel:(option:any)=>option?.DisplayName ?? '',
    //         // valueFormatter: (value: any) => value?.DisplayName ?? '',
    //         // valueSetter(value: any, row) {
    //         //     return { 
    //         //         ...row, 
    //         //         CustomerVoiceName: value?.DisplayName ?? '', 
    //         //         CustomerVoiceId: value?.id ?? ''    
    //         //     };
    //         // },
    //         // valueGetter(val, row) {                
    //         //     return {
    //         //         DisplayName: row?.CustomerVoiceName ?? '',
    //         //         id: row?.CustomerVoiceId ?? ''
    //         //     }
    //         // }
    //     },
    //     {
    //         field: 'Remarks',
    //         headerName: 'SA Observations',
    //         width: 150,
    //         headerAlign: 'left',
    //         editable: false,
    //     },
    //     {
    //         field: 'FIstatus',
    //         headerName: 'FI status',
    //         width: 150,
    //         headerAlign: 'left',
    //         // renderCell: ({ row }) => {
    //         //     return <Chip label={row?.FIstatus}
    //         //         color="info"
    //         //         variant="filled"
    //         //         sx={{
    //         //             padding: '2px 10px ',
    //         //             borderRadius: '6px',
    //         //         }}
    //         //     />
    //         // }
    //     },
    //     {
    //         field: 'FI remark',
    //         headerName: 'FI remark',
    //         width: 150,
    //         headerAlign: 'left',
    //         editable: false,
    //     },
    //     {
    //         field: 'FI reason',
    //         headerName: 'FI reason',
    //         width: 150,
    //         headerAlign: 'left',
    //         editable: false,
    //     },
    //     {
    //         field: 'Rework',
    //         headerName: 'Rework',
    //         width: 150,
    //         headerAlign: 'left',
    //         editable: false,
    //     },
    //     {
    //         field: 'Value',
    //         headerName: 'Source',
    //         width: 150,
    //         headerAlign: 'left',
    //         editable: false,
    //         valueFormatter: (value: any) => {
    //             return value === "1" ? "Customer Voice" : value === "2" ? "Road Test" : "";
    //         },
    //     },
    //     {
    //         field: 'fiAttachment',
    //         headerName: 'FI Attachment',
    //         width: 150,
    //         align: 'center',
    //         headerAlign: 'left',
    //         renderCell: () => {
    //             return <img src={AttachmentSVG} alt="Attachment" />;
    //         },
    //     },
    // ];
    // only UAT v2.5
    var columns = [{
            type: 'searchSelect',
            field: 'ComplaintName',
            headerName: 'Customer Complaint',
            headerAlign: 'left',
            flex: 1.5,
            minWidth: 200
        }, {
            field: 'Remarks',
            headerName: 'SA Observation',
            headerAlign: 'left',
            editable: false,
            flex: 1,
            minWidth: 200
        }, {
            field: 'Value',
            headerName: 'Source',
            headerAlign: 'left',
            editable: false,
            valueFormatter: function (value) {
                return value === "1" ? "Customer Voice" : value === "2" ? "Road Test" : "";
            },
            flex: 1,
            minWidth: 200
        }];
    return /*#__PURE__*/ React.createElement(EditableDataGrid, {
        dataGridHeader: "Job items",
        isCollapsible: true,
        columns: columns
        // add and delete disabled only UAT v2.5
        ,
        disableAddRow: true,
        disableDeleteRow: true,
        dataGridProps: {
            //only UAT v2.5
            // initialState: {
            //     pinnedColumns: {
            //         left: [GRID_CHECKBOX_SELECTION_FIELD],
            //     }
            // },
            checkboxSelection: false,
            //only UAT v2.5
            disableRowSelectionOnClick: true,
            hideFooter: true,
            disableAggregation: true,
            disableColumnFilter: true,
            disableRowGrouping: true
        },
        rows: currValue || [],
        onChange: onChange,
        error: error === null || error === void 0 ? void 0 : error[name]
    });
};
